{
  "familyId": "MET-MEETK-OMTREK",
  "questions": [
    {
      "id": "MET-MEETK-OMTREK-001",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een straal van 5 cm. Wat is de omtrek? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["31,4 cm", "15,7 cm", "78,5 cm", "10 cm"],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"radius":5,"highlightRadius":true,"label":"Cirkel met straal 5 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek cirkel","content":"Omtrek = 2 × π × straal = 2 × 3,14 × 5 = 31,4 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_basic",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De formule voor de omtrek is: omtrek = 2 × π × straal. Reken stap voor stap: 2 × 3,14 = 6,28, dan 6,28 × 5 = 31,4 cm. Snelle controle: de omtrek is altijd iets meer dan 3 × diameter, dus iets meer dan 30 cm — klopt.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × π × straal",
          "Vul in: 2 × 3,14 × 5",
          "Reken: 2 × 3,14 = 6,28 → 6,28 × 5 = 31,4 cm",
          "Check: omtrek ≈ 3× diameter = 30 → klopt"
        ],
        "distractorExplanations": {
          "0": "Goed! Omtrek = 2 × π × straal = 2 × 3,14 × 5 = 31,4 cm.",
          "1": "Je hebt de factor 2 vergeten en alleen π × straal gerekend (3,14 × 5 = 15,7). Maar de formule is 2 × π × straal. Onthoud: zonder de 2 reken je een halve omtrek.",
          "2": "Je hebt de oppervlakteformule gebruikt: π × straal² = 3,14 × 25 = 78,5 cm². Maar de vraag is naar de omtrek (lengte, in cm), niet de oppervlakte (vlak, in cm²). Onthoud: omtrek = 2πr, oppervlakte = πr².",
          "3": "Je hebt de diameter gegeven (2 × 5 = 10 cm). Maar de omtrek loopt rond de cirkel — veel langer dan de diameter. Onthoud: omtrek = π × diameter ≈ 3,14 × diameter."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.cirkel-omtrek-zonder-factor-2", "label": "Factor 2 vergeten", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-als-oppervlakte", "label": "Oppervlakteformule gebruikt", "optionIndex": 2 },
          { "id": "met.cirkel-omtrek-diameter-ipv-formule", "label": "Diameter als omtrek", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-002",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een diameter van 10 cm. Vier leerlingen schreven een berekening op voor de omtrek. Welke leerling heeft het juiste antwoord én de juiste formule gebruikt? (π ≈ 3,14)",
      "context": null,
      "options": [
        "Sara: 3,14 × 5 = 15,7 cm (gebruikt π × straal)",
        "Tom: 2 × 3,14 × 10 = 62,8 cm (gebruikt 2 × π × diameter)",
        "Lin: 3,14 × 10 = 31,4 cm (gebruikt π × diameter)",
        "Bas: 3,14 × 100 = 314 cm (gebruikt π × diameter²)"
      ],
      "correctAnswer": 2,
      "stimulusAids": [{"type":"circle","data":{"diameter":10,"highlightDiameter":true,"label":"Cirkel met diameter 10 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek met diameter","content":"Omtrek = π × diameter = 3,14 × 10 = 31,4 cm. Of via straal: 2 × π × straal = 2 × 3,14 × 5 = 31,4 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_diameter_error_analysis",
      "variantIndex": 2,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Lin gebruikt de juiste formule: omtrek = π × diameter = 3,14 × 10 = 31,4 cm. Sara gebruikt π × straal (factor 2 vergeten). Tom combineert beide formules (dubbele factor 2). Bas verwart omtrek met oppervlakte (kwadrateert de diameter). Onthoud: óf π × diameter, óf 2 × π × straal — beide geven hetzelfde, want diameter = 2 × straal.",
        "solutionSteps": [
          "Bekijk elke formule kritisch: is hij geldig voor omtrek?",
          "Geldig: omtrek = π × diameter OF 2 × π × straal",
          "Lin: 3,14 × 10 = 31,4 cm — formule en uitkomst kloppen ✓",
          "Sara, Tom, Bas: formule óf uitkomst klopt niet"
        ],
        "distractorExplanations": {
          "0": "Sara gebruikt π × straal in plaats van π × diameter. Ze vergeet de factor 2. De juiste formule is π × diameter óf 2 × π × straal — niet π × straal. Lin's berekening klopt wel.",
          "1": "Tom combineert beide formules: 2 × π × diameter geeft een dubbele factor 2. π × diameter is al gelijk aan 2πr. De extra ×2 is teveel. Lin's berekening (zonder die extra 2) klopt.",
          "2": "Goed! Lin past π × diameter correct toe: 3,14 × 10 = 31,4 cm. Dit is de standaard omtrekformule met diameter.",
          "3": "Bas kwadrateert de diameter — dat is de oppervlakteformule (πr²), niet de omtrekformule. Voor omtrek vermenigvuldig je π met de diameter (niet met diameter²). Lin's berekening is correct."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-ipv-diameter-formule", "label": "Straal i.p.v. diameter", "optionIndex": 0 },
          { "id": "met.cirkel-omtrek-2pi-keer-d", "label": "Dubbele factor 2", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-als-oppervlakte", "label": "Verwart met oppervlakteformule", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-003",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een cirkel heeft een omtrek van 62,8 cm. Wat is de straal? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["20 cm", "10 cm", "5 cm", "31,4 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"radius":10,"label":"Cirkel met omtrek 62,8 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Straal uit omtrek","content":"Omtrek = 2 × π × straal, dus straal = omtrek ÷ (2π) = 62,8 ÷ 6,28 = 10 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_radius_from_circumference",
      "variantIndex": 3,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Begin bij omtrek = 2 × π × straal en draai de formule om: straal = omtrek ÷ (2 × π). Bereken eerst de noemer: 2 × 3,14 = 6,28. Dan: 62,8 ÷ 6,28 = 10 cm. Controleer: 2 × 3,14 × 10 = 62,8 ✓. Onthoud: bij terugrekenen ondoe je beide bewerkingen — delen door 2 én door π.",
        "solutionSteps": [
          "Begin met: omtrek = 2 × π × straal",
          "Draai om: straal = omtrek ÷ (2 × π)",
          "Reken noemer: 2 × 3,14 = 6,28",
          "Deel: 62,8 ÷ 6,28 = 10 cm",
          "Check: 2 × 3,14 × 10 = 62,8 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de diameter berekend (62,8 ÷ π ≈ 20 cm), niet de straal. Onthoud: deel óók nog door 2 om bij de straal te komen, of deel direct door (2 × π).",
          "1": "Goed! Straal = 62,8 ÷ (2 × 3,14) = 62,8 ÷ 6,28 = 10 cm.",
          "2": "Je hebt door een te grote factor gedeeld (waarschijnlijk 4π ≈ 12,56). De juiste deler is 2π = 6,28: 62,8 ÷ 6,28 = 10 cm. Onthoud: precies 2π, niet meer.",
          "3": "Je hebt 62,8 ÷ 2 = 31,4 gerekend en de π weggelaten. Maar in de omtrekformule zit zowel een 2 als een π. Onthoud: deel altijd door 2π, niet door 2 alleen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-uit-omtrek-deel-pi", "label": "Alleen ÷ π (geeft diameter)", "optionIndex": 0 },
          { "id": "met.cirkel-straal-uit-omtrek-deel-vier-pi", "label": "÷ 4π i.p.v. ÷ 2π", "optionIndex": 2 },
          { "id": "met.cirkel-straal-uit-omtrek-deel-2", "label": "Alleen ÷ 2 (π vergeten)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-004",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "Een fietswiel heeft een diameter van 70 cm. Hoeveel omwentelingen maakt het wiel ongeveer om een afstand van 100 meter af te leggen? (π ≈ 3,14)",
      "context": null,
      "options": [
        "Ongeveer 45 omwentelingen",
        "Ongeveer 143 omwentelingen",
        "Ongeveer 1.430 omwentelingen",
        "Ongeveer 219 omwentelingen"
      ],
      "correctAnswer": 0,
      "stimulusAids": [{"type":"circle","data":{"diameter":70,"highlightDiameter":true,"label":"Fietswiel ∅ 70 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Stap voor stap","content":"Stap 1: omtrek = π × 70 ≈ 219,8 cm. Stap 2: zet 100 m om naar cm: 100 m = 10.000 cm. Stap 3: deel 10.000 ÷ 219,8 ≈ 45,5 → ongeveer 45 omwentelingen.","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_multi_step_context",
      "variantIndex": 4,
      "citoDifficulty": 0.58,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: 1 omwenteling = 1× de omtrek. Bereken eerst de omtrek (π × 70 = 219,8 cm), zet de afstand om naar dezelfde eenheid (100 m = 10.000 cm), en deel: 10.000 ÷ 219,8 ≈ 45,5. Afgerond: ongeveer 45 omwentelingen. Onthoud: bij wielen + afstand zijn er altijd 3 stappen — omtrek, eenheid gelijktrekken, delen.",
        "solutionSteps": [
          "Stap 1: bereken de omtrek = π × diameter = 3,14 × 70 = 219,8 cm",
          "Stap 2: zet de afstand om: 100 m = 10.000 cm",
          "Stap 3: deel: 10.000 ÷ 219,8 ≈ 45,5",
          "Antwoord: ongeveer 45 omwentelingen"
        ],
        "distractorExplanations": {
          "0": "Goed! Omtrek = 219,8 cm, en 10.000 cm ÷ 219,8 ≈ 45 omwentelingen. Drie stappen: omtrek, eenheden gelijktrekken, delen.",
          "1": "Je hebt waarschijnlijk 100 m ÷ 70 cm gerekend en de eenheden niet gelijk getrokken. Zet eerst om naar cm: 100 m = 10.000 cm. Deel dan door de omtrek (219,8 cm), niet door de diameter.",
          "2": "Je hebt de eenheden omgekeerd toegepast: 100 m ÷ 7 cm of een vergelijkbare fout. 100 m = 10.000 cm; deel door de omtrek 219,8 cm voor ongeveer 45 omwentelingen, niet 1.430.",
          "3": "Je hebt waarschijnlijk de omtrek (219,8 cm) als antwoord gegeven. Maar de vraag is hoeveel omwentelingen voor 100 m, niet de afstand per omwenteling. Deel: 10.000 ÷ 219,8 ≈ 45 omwentelingen."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-omtrek-eenheid-fout", "label": "Eenheden niet omgerekend (m vs cm)", "optionIndex": 1 },
          { "id": "met.cirkel-omtrek-eenheid-fout", "label": "Eenheden omgekeerd toegepast", "optionIndex": 2 },
          { "id": "met.cirkel-omtrek-diameter-ipv-formule", "label": "Omtrek zelf gegeven", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-005",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "multiple_choice",
      "question": "De omtrek van een cirkel is 94,2 cm. Wat is de diameter? (gebruik π ≈ 3,14)",
      "context": null,
      "options": ["15 cm", "30 cm", "47,1 cm", "60 cm"],
      "correctAnswer": 1,
      "stimulusAids": [{"type":"circle","data":{"diameter":30,"label":"Cirkel met omtrek 94,2 cm"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Diameter uit omtrek","content":"Omtrek = π × diameter, dus diameter = omtrek ÷ π = 94,2 ÷ 3,14 = 30 cm.","icon":"lightbulb"}}],
      "conceptId": "circle_diameter_from_circumference",
      "variantIndex": 5,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Begin met omtrek = π × diameter en draai om: diameter = omtrek ÷ π = 94,2 ÷ 3,14 = 30 cm. Controleer: 3,14 × 30 = 94,2 ✓. Onthoud: deel altijd door π — niet door 2 of door 2π — om de diameter terug te vinden.",
        "solutionSteps": [
          "Begin met: omtrek = π × diameter",
          "Draai om: diameter = omtrek ÷ π",
          "Vul in: 94,2 ÷ 3,14 = 30 cm",
          "Check: 3,14 × 30 = 94,2 ✓"
        ],
        "distractorExplanations": {
          "0": "Je hebt de straal berekend (94,2 ÷ 6,28 = 15) i.p.v. de diameter. Onthoud: voor de diameter deel je door π alleen, niet door 2π.",
          "1": "Goed! 94,2 ÷ 3,14 = 30 cm.",
          "2": "Je hebt de omtrek door 2 gedeeld (94,2 ÷ 2 = 47,1) en de π weggelaten. Maar diameter = omtrek ÷ π, niet ÷ 2. Onthoud: π hoort er bij.",
          "3": "Je hebt door een te kleine factor gedeeld. De juiste deler is precies π = 3,14: 94,2 ÷ 3,14 = 30 cm. Onthoud: deel exact door π."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.cirkel-straal-uit-omtrek-deel-vier-pi", "label": "÷ 2π geeft straal", "optionIndex": 0 },
          { "id": "met.cirkel-diameter-uit-omtrek-deel-2", "label": "÷ 2 (π vergeten)", "optionIndex": 2 },
          { "id": "met.cirkel-diameter-uit-omtrek-deel-fout", "label": "Verkeerde deler", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-MEETK-OMTREK-006",
      "familyId": "MET-MEETK-OMTREK",
      "module": "Metriek",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "cirkels",
      "subSkill": "meetk_omtrek_cirkel",
      "questionType": "fill_in",
      "question": "Een tuinontwerper maakt een rond bloembed met een straal van 4 meter. Wat is de omtrek in meters? (π ≈ 3,14, rond af op 1 decimaal)",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["25,1", "25.1", "25,12", "25.12"],
        "caseSensitive": false,
        "placeholder": "... m"
      },
      "stimulusAids": [{"type":"circle","data":{"radius":4,"highlightRadius":true,"label":"Rond bloembed met straal 4 m"}}],
      "supportAids": [{"type":"rule","showWhen":"wrong","data":{"title":"Omtrek cirkel","content":"Omtrek = 2 × π × straal = 2 × 3,14 × 4 = 25,12 m → 25,1 m (1 decimaal).","icon":"lightbulb"}}],
      "conceptId": "circle_circumference_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Omtrek = 2 × π × straal = 2 × 3,14 × 4. Stap voor stap: 2 × 3,14 = 6,28, dan 6,28 × 4 = 25,12 m. Afgerond op 1 decimaal: 25,1 m. De tuinontwerper heeft dus ruim 25 meter randmateriaal nodig.",
        "solutionSteps": [
          "Formule: omtrek = 2 × π × straal",
          "Invullen: 2 × 3,14 × 4",
          "Stap voor stap: 2 × 3,14 = 6,28 → 6,28 × 4 = 25,12 m",
          "Afronden op 1 decimaal: 25,1 m"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}